import axios from "../axios";
import * as endPoints from "../endpoints";

export const uploadImageApi = async (data) =>
  Promise.resolve(axios.post(endPoints.imageUpload, data));

export const fileUploadApi = async (data) =>
  Promise.resolve(axios.post(endPoints.fileUpload, data));
